export const formatVideoPromoInput = (raw: string, previous: string, isDuration: boolean) => {
  if (/[^\d:]/.test(raw)) return previous;
  if (/^\d{3,6}$/.test(raw)) return (raw.match(/.{1,2}/g) ?? []).join(':');
  if (raw.length > previous.length && (/^\d{2}$/.test(raw) || (isDuration && /^\d{2}:\d{2}$/.test(raw)))) {
    return `${raw}:`;
  }
  return raw;
};
